<template>
  <v-bottom-sheet
    v-model="showDisputesMenu"
    inset
    class="rounded"
    width="90%"
    v-if="$route.name !== 'NoAccess' && $route.name !== 'AccessDenied'"
  >
    <v-list density="comfortable">
      <MenuSheetTitle @close="showDisputesMenu = false" />

      <v-divider></v-divider>

      <!-- Marketing home -->
      <v-list-item
        prepend-icon="mdi-home"
        title="Marketing Home"
        subtitle="Back to marketing overview"
        @click="goToMarketingHome"
      />
    </v-list>
  </v-bottom-sheet>
</template>

<script setup>
import MenuSheetTitle from "@/components/MenuSheetTitle.vue";
import { useRouter } from "vue-router";
import { useApp } from "@/composables/useApp.js";

const router = useRouter();
const { showDisputesMenu } = useApp();

function goToMarketingHome() {
  showDisputesMenu.value = false;
  router.push("/marketing");
}
</script>
